const PageHeader = ({ children, img, title = ' ' }) => {
	return (
		<div className='relative'>
			<img src={img} alt='Header-Image' className='w-full h-auto' />

			<div
				style={{ fontFamily: 'MyCustomFont, sans-serif' }}
				className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-[#be5169] font-bold text-2xl md:text-4xl lg:text-6xl 2xl:text-8xl z-10 whitespace-nowrap'
			>
				{/* Wrapping each letter in a span for animation */}
				{title.split('').map((letter, index) => (
					<span
						key={index}
						className='inline-block opacity-0 animate-fade-in'
						style={{
							animationDelay: `${index * 0.1}s`,
							textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
						}}
					>
						{letter}
					</span>
				))}
			</div>

			{children}

			<style jsx>
				{' '}
				{`
					@keyframes fadeIn {
						from {
							opacity: 0;
							transform: translateY(20px);
						}
						to {
							opacity: 1;
							transform: translateY(0);
						}
					}

					.animate-fade-in {
						animation: fadeIn 0.5s ease forwards;
					}
				`}{' '}
			</style>
		</div>
	);
};

export default PageHeader;
